<template>
    <div class="page">
        <div class="page-content">
            <el-card class="box-card" header="资金数据">
                <el-descriptions :column="5" border>
                    <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="累计可用消费券">{{ getSystemAllMoney.money1 }}</el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="累计补贴凭证">{{ getSystemAllMoney.money2 }}</el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="绿色积分(供参考)">{{ getSystemAllMoney.money3 }}</el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="累计补贴消费券">{{ getSystemAllMoney.money4 }}</el-descriptions-item>
                    <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="累计补贴市场">{{ getSystemAllMoney.money5 }}</el-descriptions-item>
                </el-descriptions>
            </el-card>

            <el-card class="box-card" style="margin-top: 20px" header="补贴数据">
                <el-form ref='retreatForm' size='small' :inline="true" :model='inputForm' label-width='0px'>
                    <div style="display: flex;align-items: center;color: #1f1e1e">
                        <span>首次补贴：首次凭证(</span>
                        <el-form-item style="margin: 0 4px;">
                            <el-input style='width: 100px' size="small" v-model="subsidyData.incomeVoucher" :disabled='true'></el-input>
                        </el-form-item>
                        <span>) * 首次比率(</span>
                        <el-form-item style="margin: 0 4px;">
                            <el-input style='width: 100px' size="small" v-model="subsidyData.firstRatio" :disabled='true'></el-input>
                        </el-form-item>
                        <span>) = 首次补贴(</span>
						<el-form-item style="margin: 0 4px;">
						    <el-input style='width: 100px' size="small" v-model="subsidyData.firstSubsidy" :disabled='true'></el-input>
						</el-form-item>
						<span>)</span>
                    </div>
					<div style="display: flex;align-items: center;color: #1f1e1e">
					    <span>非首次补：上次基数(</span>
					    <el-form-item style="margin: 0 4px;">
					        <el-input style='width: 100px' size="small" v-model="subsidyData.lastSubsidy" :disabled='true'></el-input>
					    </el-form-item>
					    <span>) * 增长比率(</span>
					    <el-form-item style="margin: 0 4px;">
					        <el-input style='width: 100px' size="small" v-model="subsidyData.incrementRatio" :disabled='true'></el-input>
					    </el-form-item>
					    <span>) = 本次补贴(</span>
						<el-form-item style="margin: 0 4px;">
						    <el-input style='width: 100px' size="small" v-model="(subsidyData.lastSubsidy * subsidyData.incrementRatio).toFixed(4)" :disabled='true'></el-input>
						</el-form-item>
						<span>)</span>
					</div>
                    <div style="display: flex;align-items: center;margin-top: 20px;color: #1f1e1e">
                        <span>当前可用金额(</span>
                        <el-form-item style="margin: 0 4px;">
                            <el-input style='width: 100px' size="small" v-model="subsidyData.currentAvaliable" :disabled='true'></el-input>
                        </el-form-item>
                        <span>)</span>
						
						<span> >= </span>
						
						<span>拟定需要金额(</span>
						<el-form-item style="margin: 0 4px;">
						    <el-input style='width: 100px' size="small" v-model="(subsidyData.firstSubsidy + subsidyData.lastSubsidy * subsidyData.incrementRatio).toFixed(4)" :disabled='true'></el-input>
						</el-form-item>
						<span>)</span>
						
						<span> ? 是否满足补贴条件(</span>
						<el-tag style="margin: 0 4px" size="small" type="success" v-if="subsidyData.currentAvaliable >= subsidyData.firstSubsidy + subsidyData.lastSubsidy * subsidyData.incrementRatio">满足</el-tag>
						<el-tag style="margin: 0 4px" size="small" type="danger" v-if="subsidyData.currentAvaliable < subsidyData.firstSubsidy + subsidyData.lastSubsidy * subsidyData.incrementRatio">不满足</el-tag>
						<span>)</span>
                    </div>
                    <div style="display: flex;align-items: center;margin-top: 20px;color: #1f1e1e">
                        <span>当前补贴发放状态(</span>
                        <el-tag style="margin: 0 4px" size="small" type="success" v-if="subsidyData.sendStatus == 1">蓄力中</el-tag>
                        <el-tag style="margin: 0 4px" size="small" type="danger" v-if="subsidyData.sendStatus == 2">发放中</el-tag>
                        <span>)</span>
						<el-button size="mini" type="primary" @click="openSendStatus" style="margin-left: 10px;" v-if="subsidyData.sendStatus == 1">开启发放</el-button>
                    </div>
                    <div style="display: flex;align-items: center;margin-top: 20px;color: #1f1e1e">
                        <span>当前补贴手自状态(</span>
                        <el-radio-group style="margin: 0 4px;" v-model='subsidyData.subsidyStatus' @change="changeValue">
                            <el-radio :label='1'>自动</el-radio>
                            <el-radio :label='2'>手动</el-radio>
                        </el-radio-group>
                        <span>)</span>
                        <el-button size="mini" type="primary" @click="confirmStart" style="margin-left: 10px;" v-if="subsidyData.subsidyStatus == 2">开始补贴</el-button>
                    </div>
                </el-form>
            </el-card>

        </div>
    </div>
</template>

<script>
import { get, post } from '@/utils/request.js';
export default {
    data() {
        return {
            getSystemAllMoney: {
                money1: 0,//系统可用消费券
                money2: 0,//系统消费券额度
                money3: 0,//系统动券宝额度
                money4: 0,//累计补贴消费券
                money5: 0//	累计补贴动券宝
            },
			
			subsidyData:{
				incomeVoucher:0,
				firstRatio:0,
				firstSubsidy:0,
				
				lastSubsidy:0,
				incrementRatio:0,
				currentMoney:0,
				
				currentAvaliable:0,
				
				sendStatus:0,
				subsidyStatus:0
				
			}
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getData(){
            this.getAllMoney();
        },
        getAllMoney(){
            get('/shop/utils/getIncomeVoucher').then((res)=>{
                if(res.success){
                    this.getSystemAllMoney.money1 = res.incomeVoucher.userMoney;
                    this.getSystemAllMoney.money2 = res.incomeVoucher.currency8;
                    this.getSystemAllMoney.money3 = res.incomeVoucher.currency9;
                    this.getSystemAllMoney.money4 = res.incomeVoucher.sendedCurrency8;
                    this.getSystemAllMoney.money5 = res.incomeVoucher.sendedCurrency9;
					
					this.subsidyData.incomeVoucher = res.incomeVoucher.incomeVoucher;
					this.subsidyData.firstRatio = res.incomeVoucher.firstRatio;
					this.subsidyData.firstSubsidy = res.incomeVoucher.firstSubsidy;
					this.subsidyData.lastSubsidy = res.incomeVoucher.lastSubsidy;
					this.subsidyData.incrementRatio = res.incomeVoucher.incrementRatio;
					this.subsidyData.currentMoney = res.incomeVoucher.currentMoney;	
									
					this.subsidyData.currentAvaliable = res.incomeVoucher.currentAvaliable;
			
                    this.subsidyData.sendStatus = res.incomeVoucher.sendStatus;
					this.subsidyData.subsidyStatus = res.incomeVoucher.subsidyStatus;
                }
            })
        },
		openSendStatus(val){
			
			let isOk = this.subsidyData.currentAvaliable >= this.subsidyData.firstSubsidy + this.subsidyData.lastSubsidy * this.subsidyData.incrementRatio;
			if(isOk){
				post('/shop/subsidyrecord/openSendStatus',{}).then((res)=>{
				    if(res.success){
				        this.$message({
				            message: '操作成功',
				            type: 'success',
				            duration: 2000
				        });
				    }else{
				        this.$message({
				            message: res.msg,
				            type: 'error',
				            duration: 2000
				        });
				    }
				})
			}else{
				this.$message({
				    message: '不满足补贴条件，无法开启',
				    type: 'error',
				    duration: 2000
				});
			}
		    
		},
        changeValue(val){
            post('/shop/subsidyrecord/changeIncomeVoucherStatus',{}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 2000
                    });
                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            })
        },
        confirmStart(){
            post('/shop/subsidyrecord/startIncomeVoucher',{}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 2000
                    });
                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            })
        },
    }


};
</script>

<style scoped lang="scss">
::v-deep .el-input__inner{
    padding: 0 5px;
    text-align: center;
}
::v-deep .el-radio{
    margin-right: 10px;
}
</style>